/**
 * Perfil · Ayuda: who answers what (Daniel, 13 Oct 2026). Aventuria handles trips and Apartados,
 * Kuspit the wallet, Peso a Peso the "Viaja ahora, paga después" loans. Shared by web and mobile.
 */
export type HelpContactIcon = "plane" | "wallet" | "hand-coins";

export interface HelpContact {
  id: "aventuria" | "kuspit" | "peso-a-peso";
  icon: HelpContactIcon;
  topic: string;
  partner: string;
  email: string | null;
  /** As displayed, grouped for reading. */
  phone: string;
  hours: string;
}

export const HELP_SECTION = {
  eyebrow: "Ayuda",
  title: "¿Necesitas ayuda?",
  subtitle: "Elige el tema y te conectamos con quien puede resolverlo."
} as const;

const HOURS = "Lun – vie · 9:00 – 18:00 h";

export const HELP_CONTACTS: readonly HelpContact[] = [
  { id: "aventuria", icon: "plane", topic: "Tu viaje y apartados", partner: "Aventuria", email: "atencion@aventuria.mx", phone: "55 2043 5900", hours: HOURS },
  { id: "kuspit", icon: "wallet", topic: "Tu wallet", partner: "Kuspit Casa de Bolsa", email: "clientes@kuspit.com", phone: "800 110 9090", hours: HOURS },
  { id: "peso-a-peso", icon: "hand-coins", topic: "Viaja ahora, paga después", partner: "Peso a Peso Credipyme", email: null, phone: "722 942 1661", hours: HOURS }
];

export function telHref(phone: string): string {
  return `tel:${phone.replace(/\D/g, "")}`;
}

export function mailtoHref(email: string): string {
  return `mailto:${email}`;
}
